import { render, staticRenderFns } from "./VAudioElementWrapper.vue?vue&type=template&id=66716444&"
import script from "./VAudioElementWrapper.vue?vue&type=script&lang=ts&"
export * from "./VAudioElementWrapper.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports